import React, { FC } from 'react';
import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';

import { WithDivProps } from '../../../internal/styles/types';
import wavesEffect from '../wavesEffect';
import { SkeletonPlaceholderProps } from './types';
import base from './variants/base';
import size from './variants/size';

const StyledPlaceholder = styled('div', {
  shouldForwardProp,
})<SkeletonPlaceholderProps>(base, size, wavesEffect);

const SkeletonPlaceholder: FC<WithDivProps<SkeletonPlaceholderProps>> = ({
  size = 'medium',
}) => <StyledPlaceholder size={size} />;

export default SkeletonPlaceholder;
